import { createTranslations } from '@npco/utils-translations'

export const summaryStageTranslations = createTranslations({
  secondaryButtonLabel: 'Edit',
  primaryButtonLabel: 'Pay Now',
  accountNumberLabel: 'Account Number',
})
